import {
  AccountIcon,
  AIServiceIcon,
  GPUInstanceIcon,
  LLMServiceIcon,
  OneClickDeployIcon,
  OneClickTrainingIcon,
  ServerlessGPUIcon,
  SettingIcon,
} from '@/components/ui/icons';
import siteConfig from '@/config';
import PATH_PAGE from '@/router/path';
// import { SiteConfigService } from '@/types/config';
import { DashboardIcon, PersonIcon } from '@radix-ui/react-icons';
import { Ticket, Wallet } from 'lucide-react';

export type NavItems = {
  label: string;
  href: string;
  separator?: boolean;
  strictMatch?: boolean;
  icon?: React.ReactNode;
  isHidden?: boolean;
  disabled?: boolean;
  badge?: string;
}[];

export const navSetting = [
  {
    label: 'Dashboard',
    href: PATH_PAGE.setting.workspaces.root,
    separator: true,
    icon: <DashboardIcon className="size-4" />,
    isHidden: true,
  },
  {
    label: 'Profile',
    href: PATH_PAGE.setting.profile,
    icon: <PersonIcon className="size-4" />,
  },
  // {
  //   label: 'Tokens',
  //   href: PATH_PAGE.setting.tokens,
  //   icon: <Key  className="size-4" />,
  // },
  {
    label: 'Payment',
    isHidden: !siteConfig.services.setting?.payment,
    href: PATH_PAGE.setting.payment,
    icon: <Wallet className="size-4" />,
  },
  {
    label: 'Coupon',
    href: PATH_PAGE.setting.coupon,
    icon: <Ticket className="size-4" />,
  },
  // {
  //   label: 'Service Quota',
  //   isHidden: !siteConfig.services.setting?.quota,
  //   href: PATH_PAGE.setting.serviceQuota,
  //   icon: <AlignStartVertical className="size-4" />,
  // },
];

export const navSettingWorkspace = (orgId: string = '', wsId: string = '') => [
  {
    label: 'General',
    href: PATH_PAGE.dashboard.setting.general(orgId, wsId),
  },
  {
    label: 'Organization',
    href: PATH_PAGE.dashboard.setting.organization(orgId, wsId),
  },
];

export const navConsoleFrist = (orgId: string = '', wsId: string = '') => [
  {
    label: 'Dashboard',
    href: PATH_PAGE.dashboard.workspaceById(orgId, wsId),
    icon: <DashboardIcon className="size-5" />,
    strictMatch: true,
  },
];

export const navConsole = (orgId: string = '', wsId: string = '') => [
  {
    isHidden: !siteConfig.services.llm,
    label: 'LLM as a service',
    href: PATH_PAGE.dashboard.llm?.root(orgId, wsId) ?? '',
    icon: <LLMServiceIcon className="size-5" />,
  },
  {
    isHidden: !siteConfig.services.oneClickDeploy,
    label: 'One click deploy',
    href: PATH_PAGE.dashboard.oneClickDeploy?.root(orgId, wsId) ?? '',
    icon: <OneClickDeployIcon className="size-5" />,
  },
  {
    isHidden: !siteConfig.services.serverlessGPU,
    label: 'Serverless GPU',
    href: PATH_PAGE.dashboard.serverlessGPU?.root(orgId, wsId) ?? '',
    icon: <ServerlessGPUIcon className="size-6" />,
  },
  {
    isHidden: !siteConfig.services.gpuInstance,
    label: 'GPU Instance',
    href: PATH_PAGE.dashboard.gpuInstance?.root(orgId, wsId) ?? '',
    icon: <GPUInstanceIcon className="size-5" />,
  },
  {
    isHidden: !siteConfig.services.ai,
    label: 'AI As a service',
    href: PATH_PAGE.dashboard.ai?.root(orgId, wsId) ?? '',
    icon: <AIServiceIcon className="size-5" />,
  },
  {
    isHidden: !siteConfig.services.oneClickTraining,
    label: 'One click training',
    href: PATH_PAGE.dashboard.oneClickTraining?.root(orgId, wsId) ?? '',
    icon: <OneClickTrainingIcon className="size-6" />,
    disabled: true,
  },
];

export const navConsoleFooter = (orgId: string = '', wsId: string = '') => [
  {
    label: 'Settings',
    href: PATH_PAGE.dashboard.setting.general(orgId, wsId),
    icon: <SettingIcon className="size-5" />,
  },
  {
    label: 'Account',
    href: PATH_PAGE.setting.profile,
    icon: <AccountIcon className="size-5" />,
  },
];

export const navLLMService = (orgId: string = '', wsId: string = '') => [
  {
    label: 'Overview',
    href: PATH_PAGE.dashboard.llm.root(orgId, wsId),
    strictMatch: true,
  },
  {
    label: 'Credentials',
    href: PATH_PAGE.dashboard.llm.credentials(orgId, wsId),
  },
  {
    label: 'Activity',
    href: PATH_PAGE.dashboard.llm.activity(orgId, wsId),
  },
];

export const navOneClickDeploy = (orgId: string = '', wsId: string = '') => [
  {
    label: 'All Instance',
    href: PATH_PAGE.dashboard.oneClickDeploy.root(orgId, wsId),
    strictMatch: true,
  },
];
